import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ClipboardList, ShieldCheck, FileText, Search, AlertTriangle, ChevronRight, Phone, Utensils } from 'lucide-react';
export function FoodComplaintPage() {
  return <div className="min-h-screen flex flex-col w-full bg-gov-light" data-id="element-276">
      <Header data-id="element-277" />

      <main className="flex-grow" data-id="element-278">
        {/* Page Header */}
        <div className="bg-gov-navy text-white py-10 md:py-14" data-id="element-279">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-280">
            <nav className="flex text-sm text-gray-400 mb-5" aria-label="Breadcrumb" data-id="element-281">
              <ol className="flex items-center space-x-2" data-id="element-282">
                <li data-id="element-283">
                  <a href="#home" onClick={e => {
                  e.preventDefault();
                  window.location.hash = '';
                }} className="hover:text-white transition-colors" data-id="element-284">
                    Home
                  </a>
                </li>
                <li data-id="element-285">
                  <ChevronRight className="w-3.5 h-3.5" data-id="element-286" />
                </li>
                <li data-id="element-287">
                  <a href="#report" className="hover:text-white transition-colors" data-id="element-288">
                    Report a Concern
                  </a>
                </li>
                <li data-id="element-289">
                  <ChevronRight className="w-3.5 h-3.5" data-id="element-290" />
                </li>
                <li className="text-gov-amber font-medium" aria-current="page" data-id="element-291">
                  Food Safety Complaint
                </li>
              </ol>
            </nav>
            <div className="flex items-center space-x-3 mb-3" data-id="element-292">
              <div className="bg-gov-amber/20 p-2 rounded-lg" data-id="element-293">
                <ClipboardList className="w-5 h-5 text-gov-amber" data-id="element-294" />
              </div>
              <span className="text-gov-amber font-semibold tracking-wider uppercase text-xs" data-id="element-295">
                Environmental Health Division
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black mb-3" data-id="element-296">
              Restaurant or Food Safety Complaint
            </h1>
            <p className="text-lg text-gray-300 max-w-2xl leading-relaxed" data-id="element-297">
              Report unsanitary conditions or food safety violations at a food
              establishment in Franklin County — even if no one became ill.
            </p>
          </div>
        </div>

        {/* ===== PRIMARY SECTION: Form + Context ===== */}
        <section className="bg-white border-b border-gov-border" data-id="element-298">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-299">
            <div className="flex flex-col lg:flex-row lg:items-start gap-12 lg:gap-16" data-id="element-300">
              {/* Left Column: Context */}
              <div className="lg:w-1/2 order-2 lg:order-1" data-id="element-301">
                <div className="lg:sticky lg:top-32 space-y-8" data-id="element-302">
                  <div data-id="element-303">
                    <h2 className="text-2xl md:text-3xl font-bold text-gov-navy mb-5" data-id="element-304">
                      Witnessed a food safety issue?
                      <br data-id="element-305" />
                      File a complaint.
                    </h2>
                    <p className="text-gov-slate text-lg leading-relaxed mb-4" data-id="element-306">
                      Use this form to report concerns about a restaurant,
                      grocery store, food truck, bakery, or any food
                      establishment in Franklin County where you observed
                      unsanitary or unsafe conditions — even if no one became
                      sick.
                    </p>
                    <p className="text-gov-slate leading-relaxed mb-6" data-id="element-307">
                      Your complaint triggers a review and may result in an
                      unannounced inspection by our environmental health
                      specialists.
                    </p>
                  </div>

                  {/* What you can report */}
                  <div className="bg-gov-light rounded-xl p-6 border border-gov-border" data-id="element-308">
                    <h3 className="font-bold text-gov-navy mb-4" data-id="element-309">
                      Common issues to report
                    </h3>
                    <ul className="space-y-3 text-sm text-gov-slate" data-id="element-310">
                      <li className="flex items-start" data-id="element-311">
                        <span className="bg-gov-navy text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5" data-id="element-312">
                          ✓
                        </span>
                        <span data-id="element-313">Unsanitary kitchen or dining conditions</span>
                      </li>
                      <li className="flex items-start" data-id="element-314">
                        <span className="bg-gov-navy text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5" data-id="element-315">
                          ✓
                        </span>
                        <span data-id="element-316">
                          Improper food handling or storage temperatures
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-317">
                        <span className="bg-gov-navy text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5" data-id="element-318">
                          ✓
                        </span>
                        <span data-id="element-319">Pest sightings (rodents, insects, flies)</span>
                      </li>
                      <li className="flex items-start" data-id="element-320">
                        <span className="bg-gov-navy text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5" data-id="element-321">
                          ✓
                        </span>
                        <span data-id="element-322">
                          Employee hygiene concerns (no gloves, no handwashing)
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-323">
                        <span className="bg-gov-navy text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5" data-id="element-324">
                          ✓
                        </span>
                        <span data-id="element-325">
                          Expired or spoiled food being served or sold
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-326">
                        <span className="bg-gov-navy text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5" data-id="element-327">
                          ✓
                        </span>
                        <span data-id="element-328">
                          Operating without a valid food service license
                        </span>
                      </li>
                    </ul>
                  </div>

                  {/* Urgent callout */}
                  <div className="flex items-start space-x-3 bg-amber-50 border border-amber-200 rounded-xl p-5" data-id="element-329">
                    <Phone className="w-5 h-5 text-gov-amber flex-shrink-0 mt-0.5" data-id="element-330" />
                    <div data-id="element-331">
                      <p className="text-sm text-gov-slate" data-id="element-332">
                        <strong className="text-gov-navy" data-id="element-333">
                          Someone became ill?
                        </strong>{' '}
                        If someone got sick from food, please use our{' '}
                        <a href="#report-food" className="text-gov-navy underline font-semibold hover:text-gov-amber transition-colors" data-id="element-334">
                          Foodborne Illness Report
                        </a>{' '}
                        instead, or call{' '}
                        <strong className="text-gov-navy" data-id="element-335">
                          (555) 123-4568
                        </strong>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column: The Form */}
              <div className="lg:w-1/2 order-1 lg:order-2" data-id="element-336">
                <div className="flex flex-col items-center" data-id="element-337">
                  <div className="flex items-center space-x-2 mb-5" data-id="element-338">
                    <ClipboardList className="w-5 h-5 text-gov-amber" data-id="element-339" />
                    <h3 className="font-bold text-gov-navy text-lg" data-id="element-340">
                      Submit Your Complaint
                    </h3>
                  </div>
                  <div className="flex justify-center w-full" data-id="element-341">
                    <iframe src="https://iwaspoisoned.com/widget/gov/46?=dinesafe-test1&form=1" height="550" width="100%" style={{
                    outline: 'none',
                    border: 'none',
                    maxWidth: '450px'
                  }} title="Food Safety Complaint Form" data-id="element-342"></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== SECONDARY CONTENT ===== */}
        <div style={{
        backgroundColor: '#f5f5f5'
      }} data-id="element-343">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 space-y-16" data-id="element-344">
            {/* Program Overview */}
            <section data-id="element-345">
              <h2 className="text-2xl font-bold text-gov-navy mb-6" data-id="element-346">
                About Our Food Safety Program
              </h2>
              <p className="text-gov-slate leading-relaxed mb-8 max-w-3xl" data-id="element-347">
                The Franklin County Food Safety Program works to prevent
                foodborne illness by ensuring that food provided for human
                consumption is safe, unadulterated, and honestly presented. Our
                registered environmental health specialists conduct unannounced
                inspections of all licensed food facilities.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-348">
                <div className="bg-white p-6 rounded-xl border border-gov-border shadow-sm" data-id="element-349">
                  <ShieldCheck className="w-7 h-7 text-gov-navy mb-3" data-id="element-350" />
                  <h3 className="text-base font-bold text-gov-navy mb-2" data-id="element-351">
                    Restaurant Inspections
                  </h3>
                  <p className="text-sm text-gov-slate" data-id="element-352">
                    Routine, unannounced inspections of over 3,000 food
                    establishments annually.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl border border-gov-border shadow-sm" data-id="element-353">
                  <FileText className="w-7 h-7 text-gov-navy mb-3" data-id="element-354" />
                  <h3 className="text-base font-bold text-gov-navy mb-2" data-id="element-355">
                    Licensing & Permits
                  </h3>
                  <p className="text-sm text-gov-slate" data-id="element-356">
                    All food service operations must obtain a valid license
                    before operating in the county.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl border border-gov-border shadow-sm" data-id="element-357">
                  <Utensils className="w-7 h-7 text-gov-navy mb-3" data-id="element-358" />
                  <h3 className="text-base font-bold text-gov-navy mb-2" data-id="element-359">
                    Food Handler Training
                  </h3>
                  <p className="text-sm text-gov-slate" data-id="element-360">
                    Required certification programs for food service workers to
                    ensure safe handling practices.
                  </p>
                </div>
              </div>
            </section>

            {/* Inspection Scores + Resources */}
            <section className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-361">
              <div className="bg-gov-navyDark text-white rounded-xl p-8 shadow-md flex flex-col" data-id="element-362">
                <Search className="w-8 h-8 text-gov-amber mb-4" data-id="element-363" />
                <h3 className="text-xl font-bold mb-3" data-id="element-364">
                  Check Inspection Scores
                </h3>
                <p className="text-gray-300 text-sm mb-6 flex-grow" data-id="element-365">
                  Before you dine out, look up the latest health inspection
                  results for restaurants and food facilities in Franklin
                  County.
                </p>
                <a href="#" className="block w-full text-center bg-gov-amber hover:bg-gov-amberHover text-gov-navyDark font-bold py-3 px-4 rounded transition-colors" data-id="element-366">
                  Search Restaurant Scores
                </a>
              </div>

              <div className="bg-white rounded-xl border border-gov-border p-8 shadow-sm" data-id="element-367">
                <h3 className="text-xl font-bold text-gov-navy mb-5" data-id="element-368">
                  Food Safety Resources
                </h3>
                <ul className="space-y-3" data-id="element-369">
                  <li data-id="element-370">
                    <a href="#" className="flex items-center text-gov-slate hover:text-gov-navy hover:underline transition-all text-sm" data-id="element-371">
                      <ChevronRight className="w-4 h-4 mr-2 text-gov-amber flex-shrink-0" data-id="element-372" />
                      Food Handler Training & Certification
                    </a>
                  </li>
                  <li data-id="element-373">
                    <a href="#" className="flex items-center text-gov-slate hover:text-gov-navy hover:underline transition-all text-sm" data-id="element-374">
                      <ChevronRight className="w-4 h-4 mr-2 text-gov-amber flex-shrink-0" data-id="element-375" />
                      Apply for a Food Service License
                    </a>
                  </li>
                  <li data-id="element-376">
                    <a href="#" className="flex items-center text-gov-slate hover:text-gov-navy hover:underline transition-all text-sm" data-id="element-377">
                      <ChevronRight className="w-4 h-4 mr-2 text-gov-amber flex-shrink-0" data-id="element-378" />
                      Mobile Food Truck Requirements
                    </a>
                  </li>
                  <li data-id="element-379">
                    <a href="#" className="flex items-center text-gov-slate hover:text-gov-navy hover:underline transition-all text-sm" data-id="element-380">
                      <ChevronRight className="w-4 h-4 mr-2 text-gov-amber flex-shrink-0" data-id="element-381" />
                      Temporary Event Food Permits
                    </a>
                  </li>
                  <li data-id="element-382">
                    <a href="#" className="flex items-center text-gov-slate hover:text-gov-navy hover:underline transition-all text-sm" data-id="element-383">
                      <ChevronRight className="w-4 h-4 mr-2 text-gov-amber flex-shrink-0" data-id="element-384" />
                      Current Food Recalls & Alerts
                    </a>
                  </li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer data-id="element-385" />
    </div>;
}